/**
 * Display running time as H:MM (hours, zero-padded minutes).
 * Partial hours: we **floor** total seconds to whole minutes first (not per-hour rounding).
 * Change here if product decides round-up or nearest hour instead.
 */
export function secondsToHhMm(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
  const totalMinutes = Math.floor(seconds / 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return `${h}:${String(m).padStart(2, "0")}`;
}
